{
  "cp.components.appDrawer.drawerCourses": "Kurser",
  "cp.components.appDrawer.drawerExport": "Eksport",
  "cp.components.appDrawer.drawerImprint": "Vilkår",
  "cp.components.appDrawer.drawerInstitutes": "Institutter",
  "cp.components.appDrawer.drawerSettings": "Indstillinger",
  "cp.components.appDrawer.drawerShares": "Delinger",
  "cp.components.appDrawer.drawerSingleTrainings": "Træninger",
  "cp.components.appDrawer.drawerTrainees": "Trainees",
  "cp.components.appDrawer.drawerTrainers": "Trainers",
  "cp.components.changePassword.changePasswordButton": "Skift password",
  "cp.components.changePassword.currentPassword": "Nuværende password",
  "cp.components.changePassword.equalError": "Det nye password er det samme som det gamle",
  "cp.components.changePassword.matchError": "Nye password er ikke ens",
  "cp.components.changePassword.newPassword": "Nyt password",
  "cp.components.changePassword.newPasswordRepeat": "Gentag nyt password",
  "cp.components.changePassword.newRequiredError": "Skriv nyt password",
  "cp.components.changePassword.newToShortError": "Password er for kort",
  "cp.components.changePassword.requiredError": "Skriv nuværende password",
  "cp.components.changePassword.setPasswordButton": "Indstil password",
  "cp.components.changeUserRole.errorSnackbar": "Der opstod en ukendt fejl. Prøv igen, eller kontakt supporten, hvis fejlen fortsætter.",
  "cp.components.changeUserRole.selectLabel": "Vælg rolle",
  "cp.components.changeUserRole.successSnackbar": "Ændret rolle til {rolle} ",
  "cp.components.courseTable.deleteLabel": "slet",
  "cp.components.courseTable.downloadCSVTitle": "Download CSV fil",
  "cp.components.courseTable.downloadMessage": "Download valgte kursus",
  "cp.components.courseTable.selected": "valgt",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Relateret træner",
  "cp.components.courseTable.tableRowDate": "Dato",
  "cp.components.courseTable.tableRowIdentifier": "Kursus ID",
  "cp.components.courseTable.tableRowLocation": "Lokation",
  "cp.components.courseTable.tableRowProvider": "Kursusudbyder",
  "cp.components.courseTable.tableRowTraineeCount": "Antal trainees",
  "cp.components.courseTable.tableRowValue": "Værdi",
  "cp.components.dialog.confirmDeletion.contentConclusion": "Sletningen er permanent. Denne konto vil ikke længere være tilgængelig.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Du er ved at slette en konto med følgende rolle (r):",
  "cp.components.dialog.confirmDeletion.title": "Slet den valgte konto?",
  "cp.components.footer.rightsReserved": "All rights reserved.",
  "cp.components.general.institutePageSnackbarError": "Fejl ved arkivering af institut",
  "cp.components.general.institutePageSnackbarSuccess": "Gemt",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "E-mailen er sendt inden for de sidste 10 minutter. Vent venligst, før du kan sende en anden.",
  "cp.components.general.tableRowName": "Navn",
  "cp.components.genericTable.emptyMessage": "Tom",
  "cp.components.genericTable.multiSelect": "Vælg alle",
  "cp.components.genericTable.nextPage": "Næste side",
  "cp.components.genericTable.previousPage": "Forrige side",
  "cp.components.genericTable.rowsPerPageLabel": "Rækker pr. Side:",
  "cp.components.genericTable.searchPlaceholder": "Søg",
  "cp.components.imprint.pageTitle": "Vilkår",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Invitér admin",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Brugere som må administrere institut",
  "cp.components.instituteAdminTable.adminsTableTitle": "Administratorer",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Vil du virkelig slette den valgte admin? Sletning er permanent.",
  "cp.components.instituteAdminTable.deleteLabel": "slet",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Vil du virkelig slette den valgte Trainer? Sletning er permanent.",
  "cp.components.instituteAdminTable.name": "Navn",
  "cp.components.instituteAdminTable.selected": "valgt",
  "cp.components.instituteForm.institute": "Institut",
  "cp.components.instituteForm.instituteAddress": "Instituttets adresse",
  "cp.components.instituteForm.instituteCity": "By",
  "cp.components.instituteForm.instituteCountry": "Land",
  "cp.components.instituteForm.instituteName": "Institutnavn",
  "cp.components.instituteForm.instituteSaveButton": "Gem",
  "cp.components.instituteForm.instituteState": "Region",
  "cp.components.instituteForm.instituteStreet": "Gade og husnummer",
  "cp.components.instituteForm.instituteStreetAdditional": "Andre adresseinformationer",
  "cp.components.instituteForm.instituteZIP": "Postnr.",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "English",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Français",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Sprog",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Konfigurer feedback resultater",
  "cp.components.instituteResultConfig.info": "Disse ændringer anvendes på hele \ninstituttet. For at dette kan ske, skal underviserne logge ind på CorPatch® Trainer-appen igen.",
  "cp.components.instituteResultConfig.save": "Gem konfiguration",
  "cp.components.instituteResultConfig.thresholdGood": "Grænseværdi \"god\"",
  "cp.components.instituteResultConfig.thresholdGreat": "Grænseværdi \"rigtig god\"",
  "cp.components.instituteTrainerTable.button": "Invitér trainer",
  "cp.components.instituteTrainerTable.deleteLabel": "slet",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "valgt",
  "cp.components.instituteTrainerTable.subtitle": "Alle trainere hos instituttet",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Gade",
  "cp.components.instituteTrainerTable.title": "Trainers",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Ingen trainere til rådighed",
  "cp.components.invite.inviteCancelButton": "Annuller",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Send",
  "cp.components.invite.inviteEmailSent": "E-mail sendt.",
  "cp.components.invite.inviteFirstnameLabel": "Navn",
  "cp.components.invite.inviteInvalidEmail": "Dette er ikke en gyldig E-mailadresse",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Send invitation",
  "cp.components.invite.inviteSubheader": "Der vil blive sendt en invitation til denne E-mail",
  "cp.components.invite.inviteSurnameLabel": "Efternavn",
  "cp.components.navBar.menuLabel": "menu",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Ret password",
  "cp.components.passwordForgotSetPassword.matchError": "Nye password er ikke ens",
  "cp.components.passwordForgotSetPassword.newPassword": "Nyt password",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Gentag nyt password",
  "cp.components.passwordForgotSetPassword.newRequiredError": "Indtast nyt password",
  "cp.components.passwordForgotSetPassword.newToShortError": "Det angivne password er for kort",
  "cp.components.reminder.app.appAppStoreButton": "Gå til Apple App Store",
  "cp.components.reminder.app.appPlayStoreButton": "Gå til Google Play Store",
  "cp.components.reminder.app.content": "For at bruge din CorPatch® skal du bruge CorPatch® -appen. Download det fra Google Playstore eller App Store. \n",
  "cp.components.reminder.app.title": "Vil du i gang? Hent app'en!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Velkommen",
  "cp.components.resetPassword.changePasswordButton": "Skift password",
  "cp.components.resetPassword.currentPassword": "Nuværende password",
  "cp.components.resetPassword.equalError": "Det nye password er det samme som det gamle",
  "cp.components.resetPassword.matchError": "Nye password er ikke ens",
  "cp.components.resetPassword.newPassword": "Nyt password",
  "cp.components.resetPassword.newPasswordRepeat": "Gentag nyt password",
  "cp.components.resetPassword.newRequiredError": "Indtast nyt password",
  "cp.components.resetPassword.requiredError": "Indtast nuværende password",
  "cp.components.resetPassword.setPasswordButton": "Indstil password",
  "cp.components.singleTrainingsTable.shareDialogContent": "Vælg det institut, du vil dele denne uddannelse med:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Del træning",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Del træning",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Annuller",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Udgivelse",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Delt på: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Dato",
  "cp.components.singleTrainingsTable.tableRowDepth": "Dybde",
  "cp.components.singleTrainingsTable.tableRowFlow": "Flow",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Frekvens",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Træning",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Recoil",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Del træning",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Logout",
  "cp.components.userMenu.password": "Password",
  "cp.pages.acceptInvitation.button": "Til login siden",
  "cp.pages.acceptInvitation.message": "Alt er nu indstillet, og du er klar til at gå igang!",
  "cp.pages.acceptInvitation.pageNotFound.message": "Denne invitation er ikke længere gyldig",
  "cp.pages.acceptInvitation.pageNotFound.title": "Invitation ikke fundet",
  "cp.pages.acceptInvitation.title": "Færdig.",
  "cp.pages.acceptInvitation.welcome": "Velkommen",
  "cp.pages.adminInvite.errorSnackbar": "E-mail {email} er allerede i brug",
  "cp.pages.adminInvite.inviteCardTitle": "Invitér admin",
  "cp.pages.adminInvite.successSnackbar": "E-mail sendt til {email}",
  "cp.pages.admins.adminsEmpty.button": "Invitér admin",
  "cp.pages.admins.adminsEmpty.message": "Vil du invitere den første institutadmin?",
  "cp.pages.admins.adminsEmpty.selected": "valgt",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "E-mail",
  "cp.pages.admins.adminsEmpty.tableRowName": "Navn",
  "cp.pages.admins.adminsEmpty.title": "Endnu ingen admins!",
  "cp.pages.admins.adminsNotFound.message": "Dette institut er blevet slette. ",
  "cp.pages.admins.adminsNotFound.title": "Ikke fundet!",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "institut",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Dato",
  "cp.pages.course.cellDuration": "Varighed",
  "cp.pages.course.cellFeedback": "Feedback",
  "cp.pages.course.cellName": "Navn",
  "cp.pages.course.rowDepth": "Dybde",
  "cp.pages.course.rowFlow": "Flow",
  "cp.pages.course.rowFrequency": "Frekvens",
  "cp.pages.course.rowRecoil": "Recoil",
  "cp.pages.course.title": "Kursus",
  "cp.pages.course.trainees": "Trainees",
  "cp.pages.courses.errorSnackbar": "Dette kursus kunne ikke slettes.",
  "cp.pages.courses.pageNotFoundMessage": "Blev slettet. Beklager :(",
  "cp.pages.courses.pageNotFoundTitle": "Ikke fundet.",
  "cp.pages.courses.pageTitle": "Kurser",
  "cp.pages.courses.roleInstituteAdmin": "Institutadmin",
  "cp.pages.courses.roleTrainee": "Trainee",
  "cp.pages.courses.successSnackbar": "Kurset er blevet slettet med succes.",
  "cp.pages.dashboard.cpsCount": "aktive CorPatch® -enheder",
  "cp.pages.dashboard.cpsCountRecently": "nye forbundne CorPatch®",
  "cp.pages.dashboard.lastMonth": "Udvikling sidste måned.",
  "cp.pages.dashboard.mobilesCount": "Alle mobiler er genkendt",
  "cp.pages.dashboard.mobilesCountRecently": "nyligt genkendte mobiler",
  "cp.pages.dashboard.pageTitle": "Statistik",
  "cp.pages.dashboard.trainingsCount": "afsluttede træninger",
  "cp.pages.dashboard.usersCount": "samlet antal registrerede brugere",
  "cp.pages.dashboard.usersCountRecently": "nye brugere registreret",
  "cp.pages.email.validation.button": "Gå til Login",
  "cp.pages.email.validation.text": "Tak for at du bekræftede din E-mailadresse. Vi bruger den til at holde din konto sikker og holde dig opdateret, hvis du ønsker det.",
  "cp.pages.export.pageTitle": "Eksportér kursus",
  "cp.pages.homepage.title": "Startside",
  "cp.pages.institute.PageNotFound.message": "Dette institut er blevet slettet og kan ikke længere rettes.",
  "cp.pages.institute.PageNotFound.title": "Institut ikke fundet.",
  "cp.pages.institute.institute": "institut",
  "cp.pages.institute.snackbarError": "Fejl ved arkivering af institut",
  "cp.pages.institute.snackbarSuccess": "Gemt",
  "cp.pages.institute.tabsAdmins": "Administratorer",
  "cp.pages.institute.tabsBaseData": "Grunddata",
  "cp.pages.institute.tabsTrainers": "Trainer",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Slut: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "Du har ingen aktive delingsobjekter.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "Ingen slettede delingsobjekter.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "De udgivelser, du leder efter, findes ikke.",
  "cp.pages.instituteAdminShares.pageTitle": "Udgivelser",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Ikke fundet",
  "cp.pages.instituteAdminShares.startDate": "Start: ",
  "cp.pages.institutes.addInstituteButton": "Tilføj institut",
  "cp.pages.institutes.deleteLabel": "slet",
  "cp.pages.institutes.errorSnackbar": "Institut kunne ikke slettes",
  "cp.pages.institutes.pageNotFound.message": "Vil du tilføje det første institut?",
  "cp.pages.institutes.pageNotFound.title": "Ingen institutter fundet",
  "cp.pages.institutes.pageTitle": "Institutter",
  "cp.pages.institutes.successSnackbar": "Institut blev slettet",
  "cp.pages.institutesTable.deleteWarning": "Vil du slette det valgte institut? Alle relaterede konti og data bliver slettet!",
  "cp.pages.institutesTable.instituteLowercase": "institut",
  "cp.pages.institutesTable.institutesLowercase": "institutter",
  "cp.pages.institutesTable.tableRowCity": "By",
  "cp.pages.institutesTable.tableRowCountry": "Land",
  "cp.pages.institutesTable.tableRowInstitutes": "Institutter",
  "cp.pages.institutesTable.tableRowName": "Navn",
  "cp.pages.institutesTable.tableRowStreet": "Gade",
  "cp.pages.institutesTable.tableRowZIP": "Postnr.",
  "cp.pages.internalServerError.button": "Prøv igen",
  "cp.pages.internalServerError.message": "Serveren kunne ikke færdiggøre din proces. Der var en fejl på systemet. Prøv igen senere.",
  "cp.pages.internalServerError.title": "Prøv igen senere.",
  "cp.pages.login.email": "E-mail",
  "cp.pages.login.loginButton": "Login",
  "cp.pages.login.loginInstitutesTitle": "Institutter",
  "cp.pages.login.password": "Password",
  "cp.pages.login.passwordForgot": "Glemt password?",
  "cp.pages.login.registerButton": "Registrering",
  "cp.pages.login.termsOfUseButton": "vilkår for brug",
  "cp.pages.login.userNewlyRegisteredLabel1": "Du er nu registreret",
  "cp.pages.login.userNewlyRegisteredLabel2": "Glem ikke at bekræfte din E-mail og logge ind med det samme.",
  "cp.pages.login.userOrPasswordNotFound": "Bruger eller password ikke fundet",
  "cp.pages.login.validate.errorContent": "Måske har du forsøgt at logge ind fra en anden browser eller enhed, eller du har lukket din browser i mellemtiden. Prøv at anmode om en anden E-mail for at logge ind.",
  "cp.pages.login.validate.errorSnackbar": "Der opstod en fejl ved at logge dig ind. Dit link kan være forældet.",
  "cp.pages.login.validate.errorTitle": "Vi kunne ikke genkende din browsersession",
  "cp.pages.login.validate.successContent": "Vent et øjeblik, mens vi validerer dit login.",
  "cp.pages.login.validate.successTitle": "Vi logger dig ind.",
  "cp.pages.login.validate.validationButton": "Gå tilbage til login",
  "cp.pages.login.validate.validationContent": "Vi har sendt dig en E-mail for at bekræfte dit login.",
  "cp.pages.login.validate.validationTitle": "Bekræft venligst dit login",
  "cp.pages.logout.loginButton": "Log ind",
  "cp.pages.logout.message": "Vi ses igen",
  "cp.pages.logout.title": "På gensyn!",
  "cp.pages.me.deleteOwnButtonConfirm": "Slet din konto permanent",
  "cp.pages.me.deleteOwnButtonRequest": "Slet din konto permanent",
  "cp.pages.me.deleteOwnContent": "Dette vil slette din konto permanent. Venligst bekræft at du har gemt eventuelle data før sletning af konto. Du kan ikke omgøre denne handling.",
  "cp.pages.me.familyName": "Efternavn",
  "cp.pages.me.firstName": "Navn",
  "cp.pages.me.gender": "Køn",
  "cp.pages.me.genderFemale": "Kvinde",
  "cp.pages.me.genderMale": "Mand",
  "cp.pages.me.genderOther": "Andet",
  "cp.pages.me.notFoundTitle": "Personlige indstillinger",
  "cp.pages.me.save": "Gem",
  "cp.pages.me.snackBarSaved.error": "Fejl ved arkivering af personlige indstillinger",
  "cp.pages.me.snackBarSaved.saved": "Gemt",
  "cp.pages.me.title": "Personlige indstillinger",
  "cp.pages.networkError.pageNotFound.button": "Prøv igen",
  "cp.pages.networkError.pageNotFound.message": "Serveren kunne ikke færdiggøre din proces. Har du forbindelse til internettet?",
  "cp.pages.networkError.pageNotFound.title": "Serveren ser ud til at være nede. Dette er på os! Giv det et forsøg igen senere. ",
  "cp.pages.notFound.message": "Kunne ikke finde denne side.",
  "cp.pages.notFound.title": "Ikke fundet.",
  "cp.pages.passwordForgot.confirmationMessage": "Du vil modtage en E-mail som verifikation.",
  "cp.pages.passwordForgot.confirmationMessage2": "Check om du har fået den.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Vi har sendt en E-mail med godkendelseslink til",
  "cp.pages.passwordForgot.confirmationSent": "Send E-mail",
  "cp.pages.passwordForgot.confirmationTitle": "Nulstil password",
  "cp.pages.passwordForgot.eMail": "E-mail",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Tilbage til login",
  "cp.pages.passwordForgot.passwordForgotTitle": "Glemt password",
  "cp.pages.passwordForgotSetPassword.button": "Til login siden",
  "cp.pages.passwordForgotSetPassword.message": "Alt er nu sat op, og du er klar til at gå igang!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Denne kode er ikke længere gyldig",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Ikke længere gyldig",
  "cp.pages.passwordForgotSetPassword.title": "Password ændret!",
  "cp.pages.passwordForgotSetPassword.welcome": "Velkommen",
  "cp.pages.register.acceptTermsOfUse": "Accepterer du vilkår for brug?",
  "cp.pages.register.create": "Opret konto",
  "cp.pages.register.emailField": "E-mail",
  "cp.pages.register.errorSnackbar": "Der skete en fejl. Prøv igen.",
  "cp.pages.register.firstnameField": "Fornavn",
  "cp.pages.register.lastnameField": "Efternavn",
  "cp.pages.register.newToShortError": "Det angivne password er for kort",
  "cp.pages.register.passwordField": "password",
  "cp.pages.register.successSnackbar": "Du er nu registreret",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Bjælke",
  "cp.pages.settings.feedbackMode.menuItemNone": "Ingen",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pumpe",
  "cp.pages.settings.menuItemThresholdGood": "Grænse for feedback \"god\"",
  "cp.pages.settings.menuItemThresholdGreat": "Grænse for feedback \"rigtig god\"",
  "cp.pages.settings.resultType.menuItemExpert": "Ekspert",
  "cp.pages.settings.resultType.menuItemNone": "Ingen",
  "cp.pages.settings.resultType.menuItemSimple": "Simpel",
  "cp.pages.settings.resultType.menuItemStandard": "Standard",
  "cp.pages.settings.tableRowCompression": "Kun hjertemassage",
  "cp.pages.settings.tableRowDuration": "Varighed af session",
  "cp.pages.settings.tableRowERC": "Check for vitale livstegn",
  "cp.pages.settings.tableRowFeedback": "Feedback visning",
  "cp.pages.settings.tableRowFrequency": "Målfrekvens",
  "cp.pages.settings.tableRowLocked": "Låst",
  "cp.pages.settings.tableRowProperty": "Egenskab",
  "cp.pages.settings.tableRowResult": "Resultatvisning",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Gem resultat konfiguration",
  "cp.pages.settings.tableRowSaveButton": "Gem",
  "cp.pages.settings.tableRowTrainees": "Standard antal trainees",
  "cp.pages.settings.tableRowType": "Sessionstype",
  "cp.pages.settings.tableRowValue": "Værdi",
  "cp.pages.settings.title": "Indstillinger af CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "API-adgang",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Er du sikker på, at du vil slette delingsobjektet?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Denne handling kan ikke fortrydes, men ingen data går tabt. Delingsobjektet vises som deaktiveret.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Annuller",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Fjern delingsobjekt",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Slet",
  "cp.pages.sharingObject.form.deleteButton": "Slet",
  "cp.pages.sharingObject.form.disabled": "Deaktiveret",
  "cp.pages.sharingObject.form.enabled": "Aktiveret",
  "cp.pages.sharingObject.form.invitationCode": "Invitation kode",
  "cp.pages.sharingObject.form.invitationLink": "Invitation link",
  "cp.pages.sharingObject.form.name": "Navn",
  "cp.pages.sharingObject.form.pullApiSecret": "Secret",
  "cp.pages.sharingObject.form.pullUrl": "Træk URL",
  "cp.pages.sharingObject.form.saveButton": "Gem",
  "cp.pages.sharingObject.form.title": "Deling af objekt",
  "cp.pages.sharingObject.form.webHook": "Webhook",
  "cp.pages.sharingObject.pageNotFoundDescription": "De delingsobjekter, du leder efter, findes ikke.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Ikke fundet",
  "cp.pages.sharingObject.pageTitle": "Deling af objekter",
  "cp.pages.sharingObject.snackBarDeleteError": "Kunne ikke slette",
  "cp.pages.sharingObject.snackBarDeleted": "Slettet",
  "cp.pages.sharingObject.snackBarSaveError": "Kunne ikke gemme",
  "cp.pages.sharingObject.snackBarSaved": "Gemt",
  "cp.pages.singleTraining.multipleTrainings": "træninger",
  "cp.pages.singleTraining.singleTraining": "træning",
  "cp.pages.singleTraining.table.created": "Oprettet",
  "cp.pages.singleTraining.table.name": "Fulde navn",
  "cp.pages.singleTraining.table.selected": "valgt",
  "cp.pages.singleTraining.title": "Dine træninger",
  "cp.pages.trainee.cpsButton": "Download CorPatch® Data",
  "cp.pages.trainee.delete.errorSnackbar": "Der opstod en ukendt fejl",
  "cp.pages.trainee.delete.successSnackbar": "Trainees slettet med succes",
  "cp.pages.trainee.delete.warningSnackbar": "En eller flere brugere blev ikke slettet",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Slet",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Luk",
  "cp.pages.trainee.deleteLabel": "slet",
  "cp.pages.trainee.mobileButton": "Download smartphone data",
  "cp.pages.trainee.multipleTrainees": "trainees",
  "cp.pages.trainee.singleTrainee": "trainee",
  "cp.pages.trainee.table.created": "Oprettet",
  "cp.pages.trainee.table.email": "E-mail",
  "cp.pages.trainee.table.name": "Fulde navn",
  "cp.pages.trainee.table.selected": "valgt",
  "cp.pages.trainee.title": "Trainees",
  "cp.pages.traineeShares.active": "Aktiv",
  "cp.pages.traineeShares.addDialogAdd": "Tilføj",
  "cp.pages.traineeShares.addDialogCancel": "Annuller",
  "cp.pages.traineeShares.addDialogDescription": "Indtast den invitationskode, du fik fra din partnerorganisation:",
  "cp.pages.traineeShares.addDialogDescription2": "Hvis du vælger at klikke på \"Tilføj\", bekræfter du, at du accepterer de vilkår og betingelser og den privatlivspolitik, som partnerorganisationen giver dig sammen med dette invitationslink/denne kode. Det er vigtigt at læse og forstå disse, før du fortsætter.",
  "cp.pages.traineeShares.addDialogTitle": "Invitation",
  "cp.pages.traineeShares.addShare": "Tilføj frigivelse",
  "cp.pages.traineeShares.deactivateDialogDescription": "Er du sikker på, at du vil deaktivere denne delingsaftale med {instituteName}?",
  "cp.pages.traineeShares.deactivateDialogNo": "Annuller",
  "cp.pages.traineeShares.deactivateDialogTitle": "Deaktiver",
  "cp.pages.traineeShares.deactivateDialogYes": "Deaktiver",
  "cp.pages.traineeShares.deactivateTooltip": "Deaktiver",
  "cp.pages.traineeShares.endDate": "Slutdato: ",
  "cp.pages.traineeShares.inactive": "Inaktive",
  "cp.pages.traineeShares.noActiveItemsMessage": "I øjeblikket har du ikke accepteret nogen datadeling aftaler. Tryk på plusknappen nederst til højre for at indtaste en tilsvarende invitationskode.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Ingen aktive delingsaftaler.",
  "cp.pages.traineeShares.pageNotFoundMessage": "De træningsudgivelser, du leder efter, findes ikke.",
  "cp.pages.traineeShares.pageTitle": "Udgiv Trainee",
  "cp.pages.traineeShares.pageTitleNotFound": "Ikke fundet",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Fejl ved tilføjelse af invitation: {errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Fejl ved deaktivering af deling: {errorMessage}!",
  "cp.pages.traineeShares.snackBarInvalidCode": "Indtast venligst en gyldig invitationskode.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Invitation tilføjet",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Deling deaktiveret",
  "cp.pages.traineeShares.startDate": "Startdato: ",
  "cp.pages.trainerInvite.errorSnackbar": "Email er allerede i brug",
  "cp.pages.trainerInvite.successSnackbar": "Email sendt til {email}",
  "cp.pages.trainerInvite.title": "Invitér trainer",
  "cp.pages.trainers.errorSnackbar": "Brugeren kunne ikke slettes. Prøv venligst igen!",
  "cp.pages.trainers.successSnackbar": "Slettet",
  "cp.pages.trainersNotAvailable.button": "Invitér trainer",
  "cp.pages.trainersNotAvailable.message": "Vil du invitere den første trainer?",
  "cp.pages.trainersNotAvailable.title": "Endnu ingen trainere!",
  "cp.pages.trainersNotFound.message": "Denne trainer er blevet slettet. Beklager :(",
  "cp.pages.trainersNotFound.title": "Trainer ikke fundet",
  "cp.pages.trainersTable.deleteLabel": "slet",
  "cp.pages.trainersTable.inviteTrainer": "Invitér trainer",
  "cp.pages.trainersTable.selected": "valgt",
  "cp.pages.trainersTable.tableRowEmail": "E-mail",
  "cp.pages.trainersTable.tableRowName": "Navn",
  "cp.pages.trainersTable.trainers": "Trainere",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Annuller",
  "cp.pages.userChangeEmail.changeEmail": "Ret E-mail",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "Email rettet",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "Kunne ikke rette email",
  "cp.pages.userChangeEmail.newEmail": "Ny email",
  "cp.pages.userChangeEmail.notFound.message": "Denne bruger findes ikke længere.",
  "cp.pages.userChangeEmail.notFound.title": "Ikke fundet",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "Email sendt",
  "cp.pages.userChangeEmail.verifyEmail.button": "Send mig en ny verifikationsemail til min emailadresse",
  "cp.pages.userChangeEmail.verifyEmail.content": "Vi vil gerne holde dig informeret om de seneste ændringer i vores app og produkter. Derfor har vi brug for at bekræfte din e-mailadresse.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Bekræft din e-mail",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Kunne ikke ændre password",
  "cp.pages.userChangePassword.notFound.message": "Denne bruger er blevet slettet.",
  "cp.pages.userChangePassword.notFound.title": "Brugeren blev ikke fundet.",
  "cp.pages.userChangePassword.successSnackbar": "Password ændret!",
  "cp.pages.userChangePassword.title": "Skift password",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "Nuværende password er forkert",
  "cp.pages.userDetails.errorSnackbar": "Invitationen kunne ikke sendes. ",
  "cp.pages.userDetails.invitation": "Invitation",
  "cp.pages.userDetails.notFound.message": "Disse oplysninger blev slettet. ",
  "cp.pages.userDetails.notFound.title": "Ikke fundet",
  "cp.pages.userDetails.sendInvitation": "Send invitation",
  "cp.pages.userDetails.signUpAccepted": "Accepteret",
  "cp.pages.userDetails.signUpPending": "Bearbejdes",
  "cp.pages.userDetails.successSnackbar": "Invitation sendt",
  "cp.pages.userDetails.userDetailsEmail": "E-mail"
}